const formatPriceToBRL = price =>
  parseFloat(price).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

export default formatPriceToBRL
